<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <formWrapper :validator="$v.form">
        <form @submit.prevent="handleSubmit">
          <v-row>
            <v-col cols="12" v-if="isEdited">
              <locale-select @change="fireLocaleChange" />
            </v-col>
            <v-col cols="12" md="12">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.main_image ? form.main_image.path : ''"
                :imgId="isEdited && form.main_image ? form.main_image.id : ''"
                :reset="resetImage"
                @fileSelected="handleImageSelect"
                @ImageUpdated="handleImageUpdate"
                :maxSize="maxsize"
              />
            </v-col>
            <!-- OWNER -->
            <!-- $route.name == 'edit-new-member' && -->
            <v-col v-if="member.user == null" cols="12" md="12">
              <form-group
                :validator="$v.form.user_id"
                name="user_id"
                attribute="fields.user_id"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-autocomplete
                    :items="users"
                    item-text="firstname"
                    item-value="id"
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    v-model="form.user_id"
                  >
                  </v-autocomplete>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" md="6">
              <form-group name="name">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-model="form.name"
                    outlined
                    :label="$t('labels.name')"
                    @input="hadleChange('name')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="title">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-model="form.title"
                    outlined
                    :label="$t('labels.title')"
                    @input="hadleChange('title')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="job_title" attribute="fields.job_title">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-model="form.job_title"
                    outlined
                    :label="$t('labels.job_title')"
                    @input="hadleChange('job_title')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="qualification" attribute="fields.qualification">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-model="form.qualification"
                    outlined
                    :label="$t('labels.qualification')"
                    @input="hadleChange('qualification')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="nationality" attribute="fields.nationality">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-model="form.nationality"
                    outlined
                    :label="$t('labels.nationality')"
                    @input="hadleChange('nationality')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="phone.phone" attribute="label.phone.phone">
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    :label="$t('labels.phone')"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.phone.phone"
                    outlined
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12" md="6">
              <form-group name="national_id" attribute="fields.national_id">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    type="number"
                    v-bind="attrs"
                    v-model="form.national_id"
                    outlined
                    :label="$t('labels.national')"
                    @input="hadleChange('national_id')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="company">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-model="form.company"
                    outlined
                    :label="$t('labels.company')"
                    @input="hadleChange('company')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <!-- x4 -->

            <v-col cols="12" md="6">
              <form-group name="membership_no">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    type="number"
                    v-bind="attrs"
                    v-model="form.membership_no"
                    outlined
                    :label="$t('labels.membership_no')"
                    @input="hadleChange('membership_no')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="priority">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    type="number"
                    v-bind="attrs"
                    v-model="form.priority"
                    outlined
                    :label="$t('labels.priority')"
                    @input="hadleChange('priority')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <!-- x4 -->
            <v-col cols="12" md="6">
              <form-group name="type_id" attribute="fields.type_id">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="types"
                    item-text="name"
                    item-value="id"
                    v-bind="attrs"
                    v-model="form.type_id"
                    outlined
                    :label="$t('labels.type_id')"
                    @input="hadleChange('type_id')"
                  ></v-select>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group name="gender" attribute="fields.gender">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="genders"
                    item-text="text"
                    item-value="value"
                    v-bind="attrs"
                    v-model="form.gender"
                    outlined
                    :label="$t('labels.gender')"
                    @input="hadleChange('gender')"
                  ></v-select>
                </template>
              </form-group>
            </v-col>

            <v-col cols="12">
              <v-menu
                :lang="locale"
                ref="menue"
                v-model="menue"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    v-model="form.birthdate"
                    :label="$t('fields.birthdate')"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <form-group name="birthdate" attribute="fields.birthdate">
                  <template slot-scope="{ attrs }">
                    <v-date-picker
                      :locale="locale"
                      v-bind="attrs"
                      :allowed-dates="allowedDates"
                      v-model="form.birthdate"
                      outlined
                      :label="$t('fields.birthdate')"
                      @input="(menue = false), hadleChange('birthdate')"
                    ></v-date-picker>
                  </template>
                </form-group>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <form-group name="bio">
                <template slot-scope="{ attrs }">
                  <v-textarea
                    auto-grow
                    row-height="20"
                    v-bind="attrs"
                    v-model="form.bio"
                    outlined
                    :label="$t('labels.bio')"
                    @input="hadleChange('bio')"
                  ></v-textarea>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12">
              <v-btn
                block
                large
                type="submit"
                class="primary"
                :disabled="$v.form.$invalid || !form.main_image"
                :loading="btnLoading"
                >{{ $t("button.save") }}</v-btn
              >
            </v-col>
          </v-row>
        </form>
      </formWrapper>
      <v-snackbar color="#FF0000" top v-model="showErrorToast">
        {{ $t("label.incorrectUserID") }}

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="showErrorToast = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </main>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import {
  StoreData,
  UpdateData,
  ShowData,
  UpdateMedia,
  IndexData,
} from "@/helpers/apiMethods";
import { validPhoneNumber } from "@/utils/validate";

import Cookies from "js-cookie";
import { maxWords } from "@/utils/validate";

export default {
  name: "FormComponent",
  components: {
    fileUpload: () => import("@/components/fileUpload"),
  },

  data() {
    return {
      AddMemberUserToggle: false,
      notFoundUser: false,
      resetImage: false,
      locale: this.locale,
      owner: [],
      inputLoading: false,

      form: {
        user_id: "",
        priority: "",
        membership_no: "",
        name: "",
        bio: "",
        job_title: "",
        main_image: "",
        title: "",
        company: "",
        national_id: "",
        qualification: "",
        nationality: "",
        birthdate: "",
        gender: "",
        type_id: "",
        phone: {
          phone: "",
          country_code: "00966",
        },
      },

      fileSize: 2048,

      genders: [
        { value: 1, text: this.$t("label.male") },
        { value: 2, text: this.$t("label.female") },
      ],
      types: [],
      imageFile: "",
      maxsize: 4,
      btnLoading: false,
      memberCreated: false,
      menue: false,

      inputChange: false,
      imageChange: false,
      member: {},
      timeStamp: "",
      search: null,
      users: [],
      showErrorToast: false,
    };
  },

  methods: {
    getUsers() {
      this.inputLoading = true;
      if (this.timeStamp) {
        clearTimeout(this.timeStamp);
      }
      if (this.search !== "") {
        // this.query["users?has_no_member"] = this.search;
      } else {
        this.query = {};
      }
      this.timeStamp = setTimeout(() => {
        IndexData({
          reqName: "users?has_no_member&pagination=all",
        })
          .then((res) => {
            const { data } = res.data;
            this.users = data;
          })
          .finally(() => {
            this.inputLoading = false;
          });
      }, 1000);
    },
    getTypes() {
      IndexData({ reqName: "types" }).then((res) => {
        const { data } = res.data;
        this.types = data;
      });
    },
    allowedDates(date) {
      const pickerDate = new Date(date);
      const currentDate = Date.now();
      return pickerDate < currentDate;
    },
    handleImageUpdate(photo) {
      this.$emit("update_main_image", photo);
    },
    fireLocaleChange(locale) {
      this.locale = locale;
      this.showData(locale);
    },

    showData(locale) {
      ShowData({
        reqName: "new-members",
        param: this.$route.params.slug,
        locale,
      })
        .then((res) => {
          const { member } = res.data;
          this.member = member;

          this.form = {
            ...member,
            phone: {
              phone: member.Phone.phone,
              country_code: member.Phone.country_code,
            },
            type_id: member.type.id,
            birthdate: member.birthdate ? member.birthdate : "",
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // x2
    buildData() {
      let formData = new FormData();
      if (this.form.user_id) {
        formData.append("user_id", this.form.user_id);
      }

      Object.keys(this.form).map((key) => {
        if (key !== "phone") {
          formData.append(key, this.form[key]);
        } else {
          formData.append("phone_phone", this.form[key].phone);
          formData.append("phone_country_code", "00966");
        }
      });

      if (this.isEdited) {
        formData.delete("main_image");
      }
      if (!this.form.gender) {
        formData.delete("gender");
      }
      formData.append("locale", this.locale);
      if (this.isEdited) {
        formData.append("_method", "put");
      }
      return formData;
    },
    createMethod() {
      this.btnLoading = true;
      const formData = this.buildData();

      StoreData({ reqName: "new-members", data: formData })
        .then((res) => {
          const { member } = res.data;
          this.member = member;
          this.$router.push("/new-members");
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    editMethod() {
      this.btnLoading = true;

      UpdateData({
        reqName: "new-members",
        data: this.buildData(),
        param: this.$route.params.slug,
      })
        .then((res) => {
          if (res) {
            this.$router.push("/new-members");
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    handleUpdateImage() {
      const { id } = this.form.main_image;
      const formData = new FormData();
      formData.append("file", this.imageFile);
      formData.append("_method", "put");
      formData.append("locale", this.locale);
      UpdateMedia({ id, data: formData })
        .then(() => {
          this.$emit("set_refresh");
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.reset();
        });
    },
    handleSubmit() {
      if (this.$route.name == "create-new-member") {
        // in case create
        this.createMethod();
      } else {
        // in case Edit
        this.editMethod();
      }

      if (this.imageChange && this.isEdited) {
        this.handleUpdateImage();
      }
    },
    handleImageSelect(photo) {
      if (!this.isEdited) {
        this.form.main_image = photo.file;
      } else {
        this.imageFile = photo.file;
      }
      this.imageChange = true;
    },
    hadleChange(name) {
      this.$v.form[name].$touch();
      this.inputChange = true;
    },

    reset() {
      this.$v.form.$reset();
      this.form = {};
      this.resetImage = true;
      this.imageChange = false;
      this.inputChange = false;
      this.btnLoading = false;
      this.imageChange = false;
      this.$store.dispatch("ClearServerErrors");
    },
  },
  validations: {
    form: {
      user_id: {
        minLength: minLength(1),
      },
      phone: {
        phone: {
          validPhoneNumber,
        },
      },
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      title: {
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      company: {
        maxLength: maxLength(50),
      },
      qualification: {
        maxLength: maxLength(50),
      },

      membership_no: {
        minLength: minLength(1),
        numeric,
      },
      priority: {
        numeric,
      },

      gender: {},
      nationality: {},
      national_id: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
      birthdate: {},
      job_title: {},
      priority: {
        numeric,
      },
      type_id: {
        required,
      },

      bio: {
        minLength: minLength(3),
        maxWords: maxWords(50),
      },
    },
  },
  computed: {
    isEdited() {
      if (this.$route.params.slug) {
        return true;
      } else {
        return false;
      }
    },
    formTitle() {
      if (!this.$route.params.slug) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
  },
  watch: {
    $route: {
      handler({ params, query }) {
        this.getTypes();
        this.getUsers();
        if (params.slug) {
          this.showData();
        }
        if (query.user_id) {
          this.form.user_id = Number(query.user_id);
        }
      },
      immediate: true,
    },
  },
};
</script>
